import React, { useState, useEffect, memo } from "react";
import FilterButtons from "../shared/FilterButtons";
import Wrappers from "../shared/Wrappers";
import TableMain from "../shared/TableMain";
import { GetAllDrivers } from "../../../services/admin/drivers";
import Loader from "../../shared/loader";
import SharedHeaders from "../shared/SharedHeaders";
import NotFoundIcon from "../../shared/NotFoundIcon";

const DriversMain = () => {
  const [activeButton, setactiveButton] = useState(0);
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);
  const [SearchInputValue, setSearchInputValue] = useState("");
  const [SelectedDateCallback, setSelectedDateCallback] = useState("");
  const [CurrentPage, setCurrentPage] = useState(1);

  const ButtonsArray = [
    { title: "All" },
    { title: "Pending" },
    { title: "Approved" },
  ];

  const TableHeadData = [
    { title: "ID", val: "id" },
    { title: "Name", val: "name" },
    { title: "Email", val: "email" },
    { title: "Phone number", val: "phoneNumber" },
    { title: "Account Type", val: "user_type" },
    { title: "Status", val: "status" },
    { title: "Date", val: "Date" },
  ];

  useEffect(() => {
    handleFetchAllDrivers();
  }, [activeButton, SearchInputValue, SelectedDateCallback, CurrentPage]);

  const handleFetchAllDrivers = async () => {
    const StatusType = ButtonsArray[activeButton]?.title || "";
    const Search = SearchInputValue || "";
    const Date = SelectedDateCallback || "";
    const Page = CurrentPage || 1;
    await GetAllDrivers(setLoading, setAllData, StatusType, Search, Date, Page);
  };

  return (
    <Wrappers>
      {loading && <Loader />}
      <SharedHeaders
        Placeholder="Search for Name, Email , Phone Number"
        SearchInputValue={SearchInputValue}
        setSearchInputValue={setSearchInputValue}
        HasAccountType={false}
        SelectedDateCallback={SelectedDateCallback}
        setSelectedDateCallback={setSelectedDateCallback}
      />

      <FilterButtons
        ButtonsArray={ButtonsArray}
        activeButton={activeButton}
        setactiveButton={setactiveButton}
      />

      {!loading && (
        <>
          {AllData && AllData?.data?.length > 0 ? (
            <>
              <TableMain
                TableHeadData={TableHeadData}
                BodyData={AllData?.data}
                TableType="drivers"
                CurrentPage={CurrentPage}
                setCurrentPage={setCurrentPage}
                Last_page={AllData?.last_page}
                total_pages={AllData?.total_pages}
              />
            </>
          ) : (
            !loading && <NotFoundIcon MT="20" IconWidth="10" />
          )}
        </>
      )}
    </Wrappers>
  );
};

export default memo(DriversMain);
